import styled from 'styled-components';

import { colors, responsive } from '@/utils';

export const MenuIconWrapper = styled.div<{ $menuIconBackground?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $menuIconBackground }) => $menuIconBackground ?? 'transparent'};
  border-radius: 50%;
  padding: ${responsive.spacing.small};
  width: 2.5rem;
  height: 2.5rem;
`;

export const KeyFace = styled.div`
  /* Layout */
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  min-height: 2rem;
  padding-left: ${responsive.spacing.large};
  padding-top: ${responsive.spacing.small};
  padding-right: ${responsive.spacing.large};
  padding-bottom: ${responsive.spacing.small};
  gap: ${responsive.spacing.medium};

  text-transform: uppercase;

  /* Aesthetic: The "Keycap" */
  background: ${colors.background.action.solid};
  border: 1px solid ${colors.stroke.neutral.solid['100']};
  border-radius: 8px;

  /* The "3D" Depth Effect */
  box-shadow:
    1px 2px 1px 0 ${colors.background.action.soft['50']},
    /* The thick bottom edge */ 3px 3px 2px ${colors.background.action.soft['50']}; /* The soft drop shadow */

  user-select: none;
  transition: all 0.05s ease;

  /* Interaction: Pressed state */
  &:active {
    transform: translateY(3px); /* Moves the key down */
    box-shadow:
      0 1px 0 0 ${colors.palette.neutral.light['300']},
      /* Shrinks the bottom edge */ 0 2px 5px ${colors.background.warning.soft['300']};
  }
`;
